/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Unavailable_Use_PasswordInputs */

const nl_auth_passkey_unavailable_use_password = /** @type {(inputs: Auth_Passkey_Unavailable_Use_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met een passkey lukt niet op dit toestel. Log in met je e-mailadres en wachtwoord.`)
};

/**

* @param {Auth_Passkey_Unavailable_Use_PasswordInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_passkey_unavailable_use_password = /** @type {((inputs?: Auth_Passkey_Unavailable_Use_PasswordInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Unavailable_Use_PasswordInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_passkey_unavailable_use_password(inputs)
});
export { auth_passkey_unavailable_use_password as "auth.passkey.unavailable_use_password" }